module.exports = __webpack_public_path__ + "static/media/one-drive.57e53c01.svg";